"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var GroupDescription = function GroupDescription(_ref) {
  var description = _ref.description;
  return (0, _preact.h)("div", {
    className: "widget group-details_description"
  }, (0, _preact.h)("div", {
    className: "group-content-container"
  }, (0, _preact.h)("h2", {
    className: "widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.about.this.group"
  })), (0, _preact.h)(_Content.default, {
    content: description,
    className: "group__content"
  })));
};

var _default = GroupDescription;
exports.default = _default;